// Firebase Stargazers Service
// This service fetches stargazers data from Firebase Realtime Database
// Data structure includes: id, login, name, avatar_url, location, processed_location, company, email, created_at, updated_at, last_synced

import { ref, get } from 'firebase/database';
import { database } from '../firebase/config';

export class FirebaseStargazersService {
  /**
   * Fetch stargazers data directly from Firebase Realtime Database
   * @returns {Promise<Object>} Stargazers data and stats
   */
  async getStargazers() {
    try {
      const stargazersRef = ref(database, 'website/github/stargazers');
      const snapshot = await get(stargazersRef);
      
      if (snapshot.exists()) {
        const data = snapshot.val();
        // Convert Firebase object to array format expected by the component
        const stargazersArray = Object.values(data);
        
        return {
          stargazers: stargazersArray,
          stats: {
            totalStargazers: stargazersArray.length,
            lastUpdated: new Date().toISOString()
          },
          timestamp: new Date().toISOString()
        };
      } else {
        throw new Error('No stargazers data found in database');
      }
    } catch (error) {
      console.error('Error fetching stargazers from Firebase Database:', error);
      throw error;
    }
  }

  /**
   * Fetch repository statistics from Firebase Realtime Database
   * @returns {Promise<Object>} Repository stats
   */
  async getRepoStats() {
    try {
      const statsRef = ref(database, 'website/github/stats');
      const snapshot = await get(statsRef);
      
      if (snapshot.exists()) {
        return snapshot.val();
      } else {
        return {
          totalStargazers: 0,
          lastUpdated: new Date().toISOString()
        };
      }
    } catch (error) {
      console.error('Error fetching repo stats from Firebase Database:', error);
      throw error;
    }
  }
}

// Create a singleton instance
export const firebaseStargazersService = new FirebaseStargazersService();

// Helper function to get stargazers data from Firebase
export async function getStargazersData() {
  try {
    const data = await firebaseStargazersService.getStargazers();
    return {
      stargazers: data.stargazers,
      stats: data.stats,
      source: 'firebase',
      timestamp: data.timestamp
    };
  } catch (error) {
    console.error('Failed to fetch stargazers data from Firebase:', error);
    throw new Error('Unable to load stargazers data. Please check your internet connection and try again.');
  }
}